import { getId } from '../helpers/file';
import type { ImgCloudPageKey } from '../routes/pageKeys';

const PAGE_VIEWS_ENDPOINT = '/api/img-cloud/page-views';

const sendWithFetch = (body: string): void => {
  try {
    void fetch(PAGE_VIEWS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      credentials: 'same-origin',
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Page-view reporting is best-effort and must never affect navigation.
  }
};

export const reportImgCloudPageView = (pageKey: ImgCloudPageKey): void => {
  let clientId: string | null;
  try {
    clientId = getId();
  } catch {
    return;
  }
  if (!clientId) {
    return;
  }

  const body = JSON.stringify({ pageKey, clientId });
  try {
    if (
      typeof navigator.sendBeacon === 'function' &&
      navigator.sendBeacon(PAGE_VIEWS_ENDPOINT, new Blob([body], { type: 'application/json' }))
    ) {
      return;
    }
  } catch {
    // Fall through to keepalive fetch when beacon submission is unavailable.
  }
  sendWithFetch(body);
};
